export default __webpack_public_path__ + "static/media/2.f2a27974.png";